import React from 'react';
import {Redirect} from 'react-router-dom';
import {isFromAccountingTeam, isFromTechTeam} from '../../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import Button from '@amzn/awsui-components-react/polaris/button';
import FormField from '@amzn/awsui-components-react/polaris/form-field';
import Input from '@amzn/awsui-components-react/polaris/input';
import Header from '@amzn/awsui-components-react/polaris/header';
import * as paths from '../../../util/paths';
import {TestRequest} from '../model/TestRequest';
import {TestingStatus} from '../model/TestingStatus';

const EMPTY_TEST_REQUEST_NAME: string = "";

export default function CreateNewTestRequestModal(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [testRequestName, setTestRequestName] = React.useState(EMPTY_TEST_REQUEST_NAME);
    const [testRequest, setTestRequest] = React.useState({} as TestRequest);
    const [redirectToDetailsPage, setRedirectToDetailsPage] = React.useState(false);

    const sanitizeInputName = (inputStr: string) => {
        return inputStr.replace(/[^a-zA-Z0-9 ]/g, "");
    }

    // TODO - DB call
    const mockCreateNew = (id: string) => {
        return {
            serialNumber: 1,  // assign by sorting after fetching from DDB
            identifier: id,
            userLogin: 'dewsaket',
            currentStatus: TestingStatus.InProgress,
            testPurpose: 'Mock',
            requestDescription: 'Mock',
            creationDate: '2024-03-25',
            lastUpdatedDate: '2024-03-25',
        } as TestRequest;
    }

    const onSubmitButtonClick = (event: CustomEvent) => {
        event.preventDefault();
        // TODO - Call DDB to save a new item
        console.log("Mocking interaction with DDB: " + testRequestName);

        setTestRequest(mockCreateNew(testRequestName));

        // clean up state
        setTestRequestName(EMPTY_TEST_REQUEST_NAME);
        props.setVisible(false);

        // navigate to new path
        setRedirectToDetailsPage(true);
    }

    const getRequestDetailsPath = () => {
        return paths.MANUAL_TESTING_VIEW_CURRENT_REQUEST
            .replace(':request_id', testRequest.identifier);
    }

    const onCancelButtonClick = (event: CustomEvent) => {
        event.preventDefault();
        setTestRequestName(EMPTY_TEST_REQUEST_NAME);
        props.setVisible(false);
    }

    const isEmptyInput = () => {
        return !/\S/.test(testRequestName);
    }

    const getHeaderText = () => {
        if (props.operation === 'copy') {
            return 'Copy Test Request';
        }
        return 'Create New Test Request';
    }

    const getHeaderDescription = () => {
        if (props.operation === 'copy') {
            return 'Copy from an existing test, with a different name.';
        }
        return 'Create a new test request name to associate test samples with. ' +
            'For example - this can be name of the new feature being launched.';
    }

    return (
        <Box color='inherit'>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <Modal
                    onDismiss={() => props.setVisible(false)}
                    visible={props.isVisible}
                    header={<Header
                        description={getHeaderDescription()}>
                        {getHeaderText()}
                    </Header>}
                    footer={
                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="link" onClick={onCancelButtonClick}> Cancel </Button>
                                <Button variant="primary" onClick={onSubmitButtonClick} disabled={isEmptyInput()}> Submit </Button>
                            </SpaceBetween>
                        </Box>
                    }
                >
                    <FormField label="Test Name">
                        <Input key={"create_new_test_item"}
                               controlId={"create_new_test_item"}
                               value={testRequestName}
                               onChange={(event) => setTestRequestName(sanitizeInputName(event.detail.value))}
                        />
                    </FormField>
                </Modal>
                {redirectToDetailsPage && <Redirect to={{
                    pathname: getRequestDetailsPath(),
                    state: {request: testRequest}
                }} />}
            </SpaceBetween>}
        </Box>
    );
}